import HttpHelper from '@/helpers/http';
import { ISubscription, IPaymentMethod, ISubscriptionReceipts } from '@/helpers/subscription';

interface ISubscriptionToken {
  token: string;
  mode: 'sandbox' | 'production';
}

interface ISubscriptionPlans {
  data: {
    plans: object,
    group: string,
  };
}

interface ISubscriptionResponse {
  success: boolean;
  subscription?: ISubscription;
  message?: string;
}

export interface IPaymentMethodResponse {
  success: boolean;
  paymentMethod: IPaymentMethod;
  message?: string;
}

export default class SubscriptionApi {
  static async getToken(): Promise<ISubscriptionToken> {
    return await HttpHelper.get('/api/v1/subscriptions/token');
  }

  static async getPlans(planGroup: string = null): Promise<ISubscriptionPlans> {
    return await HttpHelper.get(`/api/v1/subscriptions/plans${planGroup ? `?group=${encodeURIComponent(planGroup)}` : ''}`);
  }

  static async getInvoices(): Promise<{ 'success': boolean, invoices: ISubscriptionReceipts[]; }> {
    return await HttpHelper.get('/api/v1/subscriptions/receipts');
  }

  static async subscribe(data): Promise<ISubscriptionResponse> {
    return await HttpHelper.post('/api/v1/subscriptions/subscribe', data);
  }

  static async resubscribe(data): Promise<ISubscriptionResponse> {
    return await HttpHelper.post('/api/v1/subscriptions/resubscribe', data);
  }

  static async cancel(): Promise<ISubscriptionResponse> {
    return await HttpHelper.delete('/api/v1/subscriptions/cancel');
  }

  static async getPaymentMethod(): Promise<IPaymentMethodResponse> {
    return await HttpHelper.get('/api/v1/subscriptions/payment-method');
  }

  static async updatePaymentMethod(data): Promise<IPaymentMethodResponse> {
    return await HttpHelper.post('/api/v1/subscriptions/payment-method', data);
  }
}
